import { clientPrefix } from '@/config/base';
import request from '@/common/request';

/**
 * 分页查询医保局中药饮片
 * @param params
 * @returns
 */
export const httpPageOdsNhsaTcmDrinks = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/nhsa/pageOdsNhsaTcmDrinks`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

/**
 * 分页查询国家医保局药品（西药+中成药）数据
 * @param params
 * @returns
 */
export const httpPageOdsNhsaDrug = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/nhsa/pageOdsNhsaDrug`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

/**
 * 行政区域编码分页查询
 * @param params
 * @returns
 */
export const httpPageOdsNationalAreaCode = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/ihsp/pageOdsNationalAreaCode`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

/**
 * 广东省互联网医院监管疾病分类与代码分页查询
 * @param params
 * @returns
 */
export const httpPageOdsGdIcd10Code = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/ihsp/pageOdsGdIcd10Code`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

/**
 * 医疗服务收费项目医保目录分页查询
 * @param params
 * @returns
 */
export const httpPageOdsGdMedServiceBase = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/ihsp/pageOdsGdMedServiceBase`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

/**
 * 国家药品供应保障综合管理信息平台药品目录分页查询
 * @param params
 * @returns
 */
export const httpPageOdsNationalSupplyDrug = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/ihsp/pageOdsNationalSupplyDrug`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};

/**
 * 疾病分类与代码国家临床版2.0分页查询
 * @param params
 * @returns
 */
export const httpPageOdsDsNationalClinicV2Dim = (params: any) => {
  return request.post<any, any>(
    `${clientPrefix}/manage/nhsa/pageOdsDsNationalClinicV2Dim`,
    params,
    {
      // @ts-ignore
      isReturnAllData: true,
    },
  );
};

/**
 * 全国医疗服务项目-服务项目分页查询
 * @param params
 * @returns
 */
export const pageOdsNhsaMedServiceType = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/nhsa/pageOdsNhsaMedServiceType`, params, {
    // @ts-ignore
    isReturnAllData: true,
  });
};
/**
 * 医保医用耗材分类与代码查询
 * @param params
 * @returns
 */
export const pageOdsNhsaConsumablestypeBase = (params: any) => {
  return request.post<any, any>(
    `${clientPrefix}/manage/nhsa/pageOdsNhsaConsumablestypeBase`,
    params,
    {
      // @ts-ignore
      isReturnAllData: true,
    },
  );
};
/**
 * 全国医疗服务项目-服务项目类别查询
 * @param params
 * @returns
 */
export const findOdsNhsaMedServiceBase = (params: any) => {
  return request.post<any, any>(`${clientPrefix}/manage/nhsa/findOdsNhsaMedServiceBase`, params);
};

export const getOdsNhsaConsumablestypeDetail = (params: any) => {
  return request.post<any, any>(
    `${clientPrefix}/manage/nhsa/getOdsNhsaConsumablestypeDetail`,
    params,
    {
      // @ts-ignore
      isReturnAllData: true,
    },
  );
};
